const production = true;

const URL_API = production ? `https://api.institutoideias-sh.com.br/open/api/v1/` : `http://localhost:3000/open/api/v1/`;
const URL_BASE = production ? `https://api.institutoideias-sh.com.br/` : `http://localhost:3000/`;


export { URL_API, URL_BASE }